import { useState, useEffect, useRef } from 'react';
import { Header } from '../../components/Header';
import { Load } from '../../components/Load';
import { Sidebar } from '../../components/Sidebar';
import { Main } from '../../components/Main';
import { Form, Button, Col, Row } from 'react-bootstrap';
import { FormGroup } from '../../components/FormGroup';
import { Label } from '../../components/Label';
import InputMask from 'react-input-mask';
import AlertMessage from '../../components/Alert';
import api from '../../services/api';
import './style.css';
import errorIcon from '../../img/icon/Error.svg';
import { Password } from '@mui/icons-material';

export function RepresentanteDeVendasCadastrar() {
    const [isLoading, setIsLoading] = useState(true);

    const [nome, setNome] = useState("");
    const [numeroDocumento, setNumeroDocumento] = useState("");
    const [email, setEmail] = useState("");
    const [celular, setCelular] = useState("");
    const [chavePix, setChavePix] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [passwordStrength, setPasswordStrength] = useState({ strength: '', color: '' });

    const [error, setError] = useState("");
    const [alert, setAlert] = useState({ show: false, message: '', variant: 'success' });
    const inputRef = useRef(null);

    useEffect(() => {
        setTimeout(() => {
            setIsLoading(false);
        }, 1000);
    });

    const validateForm = () => {
        if (!email.includes('@')) {
            setError("Por favor, insira um e-mail válido.");
            return false;
        }
        if (!nome) {
            setError("Por favor, insira um nome.")
            return false;
        }
        if (!numeroDocumento) {
            setError("Por favor, selecione o número do documento.")
            return false;
        }
        if (!celular) {
            setError("Por favor, insira um celular.")
            return false
        }

        if (!password || !confirmPassword) {
            setError('Por favor, preencha os campos de senha');
            return false
        }

        if (passwordStrength.strength === 'Fraca') {
            setError('A senha é muito fraca. Por favor, escolha uma senha mais forte.');
            return false
        }

        if (password !== confirmPassword) {
            setError('As senhas não estão iguais.');
            return false
        }
        
        setError("");
        return true;
    }
    const [userId, setUserId] = useState(0);
    const fetchData = async () => {
        try {
            // Retorna usuário logado
            const { data: user } = await api.get('dados-usuario');
            if (user.nome === "Administrador") {
                setUserId(1);
            } else {
                setUserId(user.id);
            }
        } catch (error) {
            console.error('Erro ao buscar dados:', error);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);
    const handleSubmit = async (event: any) => {
        event.preventDefault();
        if (!validateForm()) return;

        try {
            const userData = {
                nome: nome,
                documento: numeroDocumento,
                email: email,
                password: password,
                celular: celular,
                chave_pix: chavePix,
                id_credenciado: userId
            }
            const response = await api.post('representante', userData);

            if (response.status === 200) {
                setNome('');
                setNumeroDocumento('');
                setEmail('');
                setChavePix('');
                setCelular('');
                setAlert({ message: 'Responsável cadastrado', variant: 'success', show: true });
            }

        } catch (error) {
            setError("Erro ao enviar os dados. Tente novamente mais tarde.");
            console.error('Erro no registro:', error);
        }
    };

    const evaluatePasswordStrength = (password: any) => {
        if (!password) return { strength: '', color: '' };

        const length = password.length;
        const hasNumbers = /\d/.test(password);
        const hasUpperCase = /[A-Z]/.test(password);
        const hasSpecialChars = /[!@#$%^&*(),.?":{}|<>]/.test(password);

        if (length > 8 && hasUpperCase && hasNumbers && hasSpecialChars) {
            return { strength: 'Muito forte', color: 'green' };
        } else if (length > 6 && hasUpperCase && hasNumbers) {
            return { strength: 'Forte', color: 'green' };
        } else if (length > 4 && (hasUpperCase || hasNumbers || hasSpecialChars)) {
            return { strength: 'Média', color: 'yellow' };
        } else if (length > 0) {
            return { strength: 'Fraca', color: 'red' };
        }
        return { strength: '', color: '' };
    };

    const handlePasswordChange = (e: { target: { value: any; }; }) => {
        const newPassword = e.target.value;
        setPassword(newPassword);
        const strength = evaluatePasswordStrength(newPassword);
        setPasswordStrength(strength);
    };


    return (
        <div>
            <Load isLoading={isLoading} />
            <Sidebar />
            <Header route='../../' />
            <Main>
                <Form onSubmit={handleSubmit}>
                    <h3>Cadastro do Representante</h3>
                    <Row>
                        <Col xs={12} md={6} xl={6}>
                            <FormGroup>
                                <Label title='Representante' htmlFor="nome" />
                                <input
                                    type="text"
                                    id="nome"
                                    placeholder="Digite o Nome do Representante"
                                    value={nome}
                                    onChange={(e) => {
                                        setNome(e.target.value);
                                    }}
                                    style={{ width: '100%' }}
                                />
                            </FormGroup>
                        </Col>
                        <Col xs={12} md={3} xl={3}>
                            <FormGroup>
                                <Label title='Número do Documento' htmlFor="numero_documento" />
                                <InputMask
                                    ref={inputRef}
                                    value={numeroDocumento}
                                    onChange={(e: any) => setNumeroDocumento(e.target.value)}
                                    placeholder="Digite o Número do Documento"
                                    className="form-control"
                                    style={{ width: '100%' }}
                                />
                            </FormGroup>
                        </Col>
                        <Col xs={12} md={3} xl={3}>
                            <FormGroup>
                                <Label title='Email' htmlFor="email" />
                                <InputMask
                                    ref={inputRef}
                                    id='email'
                                    value={email}
                                    onChange={(e: any) => setEmail(e.target.value)}
                                    placeholder="Digite o Email"
                                    style={{ width: '100%' }}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={3} xl={3}>
                            <FormGroup>
                                <Label title='Senha' htmlFor="senha" />
                                <input
                                    className={`form-control password-input ${passwordStrength.color}`}
                                    type={showPassword ? "text" : "password"}
                                    id="senha"
                                    placeholder="Digite a senha"
                                    value={password}
                                    onChange={handlePasswordChange}
                                    style={{ width: '100%' }}
                                />
                            </FormGroup>
                        </Col>
                        <Col xs={12} md={3} xl={3}>
                            <FormGroup>
                                <Label title='Confirmar Senha' htmlFor="confirmSenha" />
                                <input
                                    className={`form-control ${password && confirmPassword && password === confirmPassword ? 'is-valid' : confirmPassword && 'is-invalid'}`}
                                    type={showPassword ? "text" : "password"}
                                    id="confirmSenha"
                                    placeholder="Confirme sua senha"
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                    style={{ width: '100%' }}
                                />
                            </FormGroup>
                        </Col>
                        <Col xs={12} md={3} xl={3}>
                            <FormGroup>
                                <Label title='Chave PIX' htmlFor="chave_pix" />
                                <InputMask
                                    ref={inputRef}
                                    id='chave_pix'
                                    value={chavePix}
                                    onChange={(e: any) => setChavePix(e.target.value)}
                                    placeholder="Digite a Chave PIX"
                                    style={{ width: '100%' }}
                                />
                            </FormGroup>
                        </Col>
                        <Col xs={12} md={3} xl={3}>
                            <FormGroup>
                                <Label title='Celular' htmlFor="celular" />
                                <InputMask
                                    ref={inputRef}
                                    mask="(99) 99999-9999"
                                    value={celular}
                                    onChange={(e: any) => setCelular(e.target.value)}
                                    placeholder="(__) _____-____"
                                    style={{ width: '100%' }}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>

                    </Row>
                    <Row>

                    </Row>
                    <Row>
                        <div className={`${passwordStrength.color}`} style={{ fontSize: '15px', marginLeft: '8px' }}>{passwordStrength.strength}</div>
                    </Row>
                    <Button className="btn-main mt-4" type="submit" onClick={handleSubmit}>Inserir Representante</Button>
                </Form>
            </Main>
            {error && (
                <div className="error-container my-3 text-danger">
                    <img
                        className="error-icon"
                        src={errorIcon}
                        alt="Error" />
                    <p className="error-text text-center mb-3">{error}</p>
                </div>
            )}
            <AlertMessage
                show={alert.show}
                message={alert.message}
                variant={alert.variant}
                onClose={() => setAlert({ ...alert, show: false })}
            />
        </div>
    );
}
